import { Route } from '@angular/router';
import {
  authGuard,
  guestGuard,
  authChildGuard,
  LoginComponent,
  RegisterComponent,
  ResetPasswordComponent,
} from '@victory-lib-ui/shared/auth';
import { MainLayoutComponent } from './shared/layout';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    canActivate: [guestGuard],
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginComponent,
        title: 'Login - Victory Bible',
      },
      {
        path: 'register',
        component: RegisterComponent,
        title: 'Register - Victory Bible',
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
        title: 'Reset Password - Victory Bible',
      },
    ],
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authChildGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
        title: 'Dashboard - Victory Bible',
      },
      {
        path: 'dictionary',
        loadComponent: () =>
          import('./dictionary/dictionary.component').then(
            (m) => m.DictionaryComponent
          ),
        title: 'Bible Dictionary - Victory Bible',
      },
      {
        path: 'dictionary/:dictionaryId/:topic',
        loadComponent: () =>
          import('./dictionary/dictionary-entry.component').then(
            (m) => m.DictionaryEntryComponent
          ),
        title: 'Dictionary Entry - Victory Bible',
      },
      {
        path: 'coming-soon/:section',
        loadComponent: () =>
          import('./coming-soon/coming-soon.component').then(
            (m) => m.ComingSoonComponent
          ),
        title: 'Coming Soon - Victory Bible',
      },
      {
        path: 'passage',
        loadComponent: () =>
          import('./passage/passage.component').then((m) => m.PassageComponent),
        title: 'Read Bible - Victory Bible',
      },
      {
        path: 'theme',
        loadComponent: () =>
          import('./theme/theme-directory.component').then(
            (m) => m.ThemeDirectoryComponent
          ),
        title: 'Themes - Victory Bible',
      },
      {
        path: 'themes/:themeId',
        loadComponent: () =>
          import('./theme/theme-page.component').then(
            (m) => m.ThemePageComponent
          ),
        title: 'Passage Theme - Victory Bible',
      },
      {
        path: 'search',
        loadComponent: () =>
          import('./search/search.component').then((m) => m.SearchComponent),
        title: 'Search - Victory Bible',
      },
      {
        path: 'audio',
        loadComponent: () =>
          import('./audio/audio.component').then((m) => m.AudioComponent),
        title: 'Audio Bible - Victory Bible',
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./settings/settings-page.component').then(
            (m) => m.SettingsPageComponent
          ),
        title: 'Profile - Victory Bible',
        data: { tab: 'profile' },
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./settings/settings-page.component').then(
            (m) => m.SettingsPageComponent
          ),
        title: 'Settings - Victory Bible',
        data: { tab: 'profile' },
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
